import React, { useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Megaphone, Settings, BarChart3, Wallet } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import { fetchConnectionStatus } from '../../redux/metaAdsSlice';

const tabs = [
  { name: 'Campaigns', to: '/dashboard/meta-ads/campaigns', icon: Megaphone },
  { name: 'Analytics', to: '/dashboard/meta-ads/analytics', icon: BarChart3 },
  { name: 'Account Balance', to: '/dashboard/meta-ads/wallet', icon: Wallet },
  { name: 'Settings', to: '/dashboard/meta-ads/settings', icon: Settings },
];

export default function MetaAdsDashboardLayout() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => { dispatch(fetchConnectionStatus()); }, [dispatch]);

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 md:px-6 pt-4 md:pt-6 bg-white border-b border-[#D8DDE6]">
        <div className="mb-4">
          <PageHeader
            title="Meta Ads"
            subtitle="Create and manage Facebook & Instagram ad campaigns — connected to your CRM."
            icon={Megaphone}
          />
        </div>
        <nav className="flex space-x-1 overflow-x-auto" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = location.pathname === tab.to;
            return (
              <NavLink
                key={tab.name}
                to={tab.to}
                className={`relative flex shrink-0 items-center gap-2 py-3 px-4 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-[#1877F2] text-[#1877F2]'
                    : 'border-transparent text-[#5C5C5C] hover:text-[#2E2E2E] hover:border-[#D8DDE6]'
                }`}
              >
                <Icon size={16} />
                {tab.name}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-auto p-4 md:p-6 bg-[#F3F3F3]">
        <Outlet />
      </div>
    </div>
  );
}
